import { FC } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useArpMedias } from '../../../../queries/arpMedia'
import CenteredLoadingAnimation from '../../../core/CenteredLoadingAnimation'
import { ArpMediaRow } from '../../arp'

interface Props {
  samplePackId: number
}

export const SamplePackSoundsTable: FC<Props> = ({ samplePackId }) => {
  const perPage = 25
  const samplePackSoundsQuery = useArpMedias({ samplePackId, perPage })

  if (samplePackSoundsQuery.isLoading) {
    return <CenteredLoadingAnimation />
  }

  return (
    <InfiniteScroll
      loader={<CenteredLoadingAnimation />}
      dataLength={samplePackSoundsQuery.data?.pages.length * perPage}
      next={samplePackSoundsQuery.fetchNextPage}
      hasMore={samplePackSoundsQuery.hasNextPage}
      style={{ overflow: 'visible' }}
    >
      {samplePackSoundsQuery.data.pages.flatMap((page) =>
        page.data.map((sound) => <ArpMediaRow key={sound.id} arpMedia={sound} />)
      )}
    </InfiniteScroll>
  )
}
